<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P243F0001">
  <div class="form-row mt-3">
    <div class="form-field">
      <input pInputText type="text" formControlName="clave_giro" class="form-control" [placeholder]="'Ingrese clave'"
        [disabled]="model" appPermissionControl="P243K0001">
      <label>Clave</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="tipo_dedicacion" class="form-control"
        [placeholder]="'Ingrese tipo de giro'" appPermissionControl="P243K0002">
      <label>Tipo Giro</label>
    </div>
  </div>

  <div class="form-row">
    <div class="form-field">
      <input pInputText type="text" formControlName="descripcion" class="form-control"
        [placeholder]="'Ingrese descripción'" appPermissionControl="P243K0003">
      <label>Descripción</label>
    </div>
  </div>

  <div class="button-section">
    <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
      [disabled]="!form.valid || loading" appPermissionControl="P243B0001">
      <mat-icon>save</mat-icon>
      {{ model ? 'Actualizar' : 'Guardar' }}
    </button>
    <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P243B0002">
      <mat-icon>tune</mat-icon>
      Customizables
    </button>
  </div>
</form>

<style>
  :host ::ng-deep .form-row {
    display: flex;
    flex-direction: row;
    margin-bottom: 1rem;
  }

  :host ::ng-deep .form-field {
    flex: 1;
    display: flex;
    flex-direction: column-reverse;
    position: relative;
  }

  :host ::ng-deep .form-control {
    width: 100%;
    padding: 0.5rem;
    font-size: 1rem;
    border: 1px solid #ced4da;
    border-radius: 4px;
    background: #fff;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  }

  :host ::ng-deep .form-control:disabled {
    background: #e0e0e0 !important;
    color: #555 !important;
    opacity: 1 !important;
  }

  :host ::ng-deep .form-field label {
    font-size: 0.85rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
  }

  :host ::ng-deep .button-section {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    margin-top: 1.5rem;
  }
</style> 